<script setup lang="ts">
  import { usePageStore } from '@/stores/page'

  const page = usePageStore()

  const emit = defineEmits<{
    (e: 'toggleSidebar'): void,
  }>()
</script>

<!--
Mobile: Hamburger Menu
Desktop: Sidebar
-->

<template>
  <nav class="navbar">
    <div class="container px-container">
      <div class="navbar-content">
        <div class="lg:hidden">
          <app-button
            class="text-gray-500 navbar-button aspect-square px-0!"
            @click="emit('toggleSidebar')">
            <fa-icon icon="i-fas-bars" />
          </app-button>
        </div>

        <div class="flex-1">
          {{ page.title }}
        </div>
      </div>
    </div>
  </nav>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .navbar-button {
    @apply flex-center;
  }
</style>
